import { IndexV2Enum } from '@/types/translations/IndexV2Enum';
import {
  createBrandUrl,
  createCategoryUrl,
  createCountyOfOriginUrl,
  createHighestBidTopicUrl,
  createLowestAskTopicUrl,
  createMostPopularTopicUrl,
  createNewestTopicUrl,
  createReleaseCalendarTopicUrl,
  createAlphabeticalTopicUrl,
} from '@/utilites/algolia/create-algolia-urls';
import {
  ImagesBrandsPopularArdbegWebp,
  ImagesBrandsPopularJohnnieWalkerPng,
  ImagesBrandsPopularLagavulinPng,
  ImagesBrandsPopularLaphroaigSingleIslayMaltScotchWhiskyLogoPng,
  ImagesBrandsPopularMacallanPng,
  ImagesBrandsPopularYamazakiPng,
} from '@/assets/images_brands_popular.assets';
import { IndexNavItem } from '@/types/constants/types';
import { IndexNavItemChildrenTypeEnum } from '@/types/constants/enums';
import { Routes } from '@/types/routes.enum';

const popularBrands = [
  {
    name: 'Macallan',
    image: ImagesBrandsPopularMacallanPng,
    href: createBrandUrl('Macallan'),
  },
  {
    name: 'Yamazaki',
    image: ImagesBrandsPopularYamazakiPng,
    href: createBrandUrl('Yamazaki'),
  },
  {
    name: 'Ardbeg',
    image: ImagesBrandsPopularArdbegWebp,
    href: createBrandUrl('Ardbeg'),
  },
  {
    name: 'Johnnie Walker',
    image: ImagesBrandsPopularJohnnieWalkerPng,
    href: createBrandUrl('Johnnie Walker'),
  },
  {
    name: 'Laphroaig',
    image: ImagesBrandsPopularLaphroaigSingleIslayMaltScotchWhiskyLogoPng,
    href: createBrandUrl('Laphroaig'),
  },
  {
    name: 'Lagavulin',
    image: ImagesBrandsPopularLagavulinPng,
    href: createBrandUrl('Lagavulin'),
  },
];

const indexNavItemsAll: IndexNavItem[] = [
  {
    label: IndexV2Enum['home_nav.type'],
    children: [
      {
        label: IndexV2Enum['home_nav.all'],
        href: '/search',
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.type_whisky'],
        href: createCategoryUrl('Whisky'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.type_rum'],
        href: createCategoryUrl('Rum'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.type_gin'],
        href: createCategoryUrl('Gin'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.type_champagne'],
        href: createCategoryUrl('Champagne'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.type_spirits'],
        href: createCategoryUrl('Spirits'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
  {
    label: IndexV2Enum['home_nav.brand'],
    children: [
      {
        label: 'Macallan',
        href: createBrandUrl('Macallan'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Ardbeg',
        href: createBrandUrl('Ardbeg'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Yamazaki',
        href: createBrandUrl('Yamazaki'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Chichibu',
        href: createBrandUrl('Chichibu'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Bowmore',
        href: createBrandUrl('Bowmore'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
    ],
  },
  {
    label: IndexV2Enum['home_nav.countries'],
    children: [
      {
        label: IndexV2Enum['home_nav.country_scotland'],
        href: createCountyOfOriginUrl('Scotland'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_france'],
        href: createCountyOfOriginUrl('France'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_japan'],
        href: createCountyOfOriginUrl('Japan'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
  {
    label: IndexV2Enum['home_nav.topics'],
    children: [
      {
        label: IndexV2Enum['home_nav.topic_new'],
        href: createNewestTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.topic_popular'],
        href: createMostPopularTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.topic_release_calendar'],
        href: createReleaseCalendarTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.topic_lowest_ask'],
        href: createLowestAskTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.topic_highest_bid'],
        href: createHighestBidTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.topic_alphabetical'],
        href: createAlphabeticalTopicUrl(),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
];

const indexNavItemsBrands: IndexNavItem[] = [
  {
    label: IndexV2Enum['home_nav.top_brands'],
    children: [
      {
        label: 'Macallan',
        href: createBrandUrl('Macallan'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Ardbeg',
        href: createBrandUrl('Ardbeg'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Springbank',
        href: createBrandUrl('Springbank'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Bowmore',
        href: createBrandUrl('Bowmore'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Yamazaki',
        href: createBrandUrl('Yamazaki'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Johnnie Walker',
        href: createBrandUrl('Johnnie Walker'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
    ],
  },
  {
    label: IndexV2Enum['home_nav.popular_brands'],
    children: [
      {
        label: 'Highland Park',
        href: createBrandUrl('Highland Park'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Laphroaig',
        href: createBrandUrl('Laphroaig'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Glenfiddich',
        href: createBrandUrl('Glenfiddich'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Lagavulin',
        href: createBrandUrl('Lagavulin'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Ardbeg',
        href: createBrandUrl('Ardbeg'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Glenmorangie',
        href: createBrandUrl('Glenmorangie'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
    ],
  },
  {
    label: IndexV2Enum['home_nav.classic_brands'],
    children: [
      {
        label: 'Bladnoch',
        href: createBrandUrl('Bladnoch'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Kavalan',
        href: createBrandUrl('Kavalan'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Bruichladdich',
        href: createBrandUrl('Bruichladdich'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
      {
        label: 'Macallan',
        href: createBrandUrl('Macallan'),
        type: IndexNavItemChildrenTypeEnum.notranslate,
      },
    ],
  },
];

const indexNavItemsCountries: IndexNavItem[] = [
  {
    label: IndexV2Enum['home_nav.countries'],
    children: [
      {
        label: IndexV2Enum['home_nav.country_scotland'],
        href: createCountyOfOriginUrl('Scotland'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_taiwan'],
        href: createCountyOfOriginUrl('Taiwan'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_usa'],
        href: createCountyOfOriginUrl('USA'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_japan'],
        href: createCountyOfOriginUrl('Japan'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_ireland'],
        href: createCountyOfOriginUrl('Ireland'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_england'],
        href: createCountyOfOriginUrl('England'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_australia'],
        href: createCountyOfOriginUrl('Australia'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_germany'],
        href: createCountyOfOriginUrl('Germany'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.country_worldwide'],
        href: createCountyOfOriginUrl('Worldwide'),
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
];

const indexNavItemsAbout: IndexNavItem[] = [
  {
    label: IndexV2Enum['home_nav.about_spiritory'],
    children: [
      {
        label: IndexV2Enum['home_nav.how_it_works'],
        href: Routes._HOW_IT_WORKS,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.buyer_guide'],
        href: Routes._BUYER_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.authentication'],
        href: Routes._AUTHENTICATING,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.portfolio_guide'],
        href: Routes._PORTFOLIO_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.bottle_condition'],
        href: Routes._CONDITION_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.faq'],
        href: '/faq',
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.seller_guide'],
        href: Routes._HELP,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
];

const indexNavItemsSellOnSpiritory: IndexNavItem[] = [
  {
    label: IndexV2Enum['home_nav.sell_on_spiritory'],
    children: [
      {
        label: IndexV2Enum['home_nav.become_a_seller'],
        href: Routes._DASHBOARD_SETTINGS_SELLER_PROFILE_BECOME_A_SELLER,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.seller_guide'],
        href: Routes._SELLER_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.authentication'],
        href: Routes._AUTHENTICATING,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.shipping_guide'],
        href: Routes._SHIPPING_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
      {
        label: IndexV2Enum['home_nav.bottle_condition'],
        href: Routes._CONDITION_GUIDE,
        type: IndexNavItemChildrenTypeEnum.translate,
      },
    ],
  },
];

const indexItemsConstants = {
  popularBrands,
  indexNavItems: {
    indexNavItemsAll,
    indexNavItemsBrands,
    indexNavItemsCountries,
    indexNavItemsAbout,
    indexNavItemsSellOnSpiritory,
  },
};

export default indexItemsConstants;
